import _ from "lodash";

// tslint:disable:object-literal-sort-keys
const en = {
  translation: {
    usecases: "USE CASES",
    security: "SECURITY",
    dashboard: "DASHBOARD",
    product: "PRODUCT",
    api: "API",
    header: {
      home: "HOME",
      product: "PRODUCT",
      developers: "DEVELOPERS",
      dashboard: "DASHBOARD",
      menus: {
        multisigWallet: "Multi-sig Wallet",
        security: "Security",
        saveGasFee: "Save Gas Fee",
        dashboardAndAPI: "Dashboard & API",
        currencies: "Currencies ",
      },
    },
    usecaseExchangeServiceCard: {
      title: `Secure The Wallet System 
With A Multi-Sig Technology.`,
      mobileTitle: `Secure The Wallet System 
With A Multi-Sig Technology.`,
      name: `Taenam Sung, CTO of Flybit`,
      description: `“Henesis supports the most secure multi-sig wallet API. We have tried 
to develop on our own, but there were so many technical challenges. 
Within 2 days, we successfully integrated Henesis and prepared 
the ISMS certification.`,
      confirmButton: `Learn More`,
    },
    usecaseDAppServiceCard: {
      title: `Provide Great User Experience 
With An In-App Crypto Wallet.`,
      mobileTitle: `Provide Great 
User Experience 
With An In-App 
Crypto Wallet.`,
      name: `Ted Kim, CEO of Zikto`,
      description: `“Our team tried to develop our own wallet but decided to adopt Henesis. 
The biggest advantage of Henesis is the enterprise-grade security. 
Also, it provides a dashboard that is very helpful for service operation."`,
      confirmButton: `Learn More`,
    },
    usecaseWalletServiceCard: {
      title: `Integrate Crypto Wallet 
With Only Two Days`,
      mobileTitle: `Integrate Crypto Wallet 
With Only Two Days`,
      name: `Jaebum Lyu, Bitberry`,
      description: `“Bitberry is the wallet service with the most users in Korea. 
My team was able to build a secure wallet in a short time with 
Henesis”`,
      confirmButton: `LEARN MORE`,
    },
    usecaseExchange2ServiceCard: {
      title: `Saving Gas Fee Means
a Huge Room For Growth `,
      mobileTitle: `Saving Gas Fee Means
a Huge Room For Growth `,
      name: `Yeongjin Yoon CTO, Flybit`,
      description: `“Being able to cut our gas fee by 90% or more has given our exchange 
a huge room to grow in several areas of our business for that we were 
able to allocate and invest that savings into acquiring new users.”`,
      confirmButton: `LEARN MORE`,
    },
    usecaseConsignmentServiceCard: {
      title: `Launch And Successfully Manage 
Your Own Crypto Custody Business`,
      mobileTitle: `Launch And Successfully Manage 
Your Own Crypto Custody Business`,
      name: `Jinseok Cho, KODA`,
      description: `“KODA has built our own cold-wallet storage by utilizing Henesis 
solution. Their world-class custody solution has enabled us to launch 
our crypto custody business and effectively manage digital assets”`,
      confirmButton: `LEARN MORE`,
    },
    usecasePaymentServiceCard: {
      title: `Henesis Helps Payment Companies 
Grow Its Users Exponentially`,
      mobileTitle: `Henesis Helps Payment Companies 
Grow Its Users Exponentially`,
      name: `Young-il Kim Team Lead, Danal Fintech`,
      description: `“Thanks to Henesis, Paycoin was able to enable Bitcoin payment, 
which helped us grow our userbase to a million+.”`,
      confirmButton: `LEARN MORE`,
    },
    multisigWalletCard: {
      title: `Multi-sig Wallet`,
      description: `The Henesis wallet consists of a total of 3 keys and 
two keys are required to create a transaction.
Three keys are generated and managed by different 
infrastructure. Even if hackers steal one key, they 
cannot withdrwal digital assets.`,
      confirmButton: `LEARN MORE`,
    },
    authorityCard: {
      title: `Policy Engine`,
      description: `Henesis has three roles: Admin, Spender and Viewer. 
Admin can build an internal control system by 
assigning roles that match their position.`,
      confirmButton: `LEARN MORE`,
    },
    withdrawalPolicyCard: {
      item1: {
        title: `Withdrawal Limit`,
        description: `Admin can set a limit of withdrawal per day and once.
Admin approval is required for withdrwal requests 
exceeding the limit.`,
      },
      item2: {
        title: `Withdrawal Address Whitelist`,
        description: `You can whitelist addresses for withdrawal. This will 
help you to control the outflow of your assets.`,
      },
      confirmButton: `LEARN MORE`,
    },
    networkSecurityCard: {
      item1: {
        title: `IP address whitelisting`,
        description: `Unathorized requests are rejected and warning 
notification is sent to the administrator.`,
      },
      item2: {
        title: `Access Token`,
        description: `Whenever calling API, a user is authenticated via 
access token.`,
      },
      item3: {
        title: `API Secret`,
        description: `Each reqeust bears a HMAC algorithm to prevent 
replay attacks.`,
      },
      confirmButton: `LEARN MORE`,
    },
    monitoringCard: {
      item1: {
        title: `Policy Monitoring`,
        description: `Instantly notify administrators when security policies 
are changed.`,
      },
      item2: {
        title: `Abnormal Behavior Monitoring`,
        description: `When abnormal behavior, a warning email is sent to 
the administrator.`,
      },
      confirmButton: `LEARN MORE`,
    },
    serviceSection: {
      title: `Cut Your Gas Fee 
By 95% For Your 
Crypto Business`,
      description: `Major banks, crypto exchanges, fintech companies, 
crypto funds, crypto custody works with Henesis.`,
      confirmButton: "TALK TO SALES",
    },
    statisticsSection: {
      title: `Focus On Your Business, 
Not Blockchain Integration.`,
      costCaption: `Average cost reduction`,
      days: " Days",
      apiCaption: `Average time for API integration`,
      amount: "$ 50M+",
      amountCaption: `Total value of stored crypto`,
    },
    usecasesSection: {
      walletTabLabel: "Crypto Wallet",
      exchange2TabLabel: "Crpyto Exchange",
      consignmentTabLabel: "Digital Asset Custody",
      paymentTabLabel: "Bitcoin Payment",
    },
    onestopSection: {
      title: `One-Stop Solution 
For Your Crypto Business`,
      multisigWallet: {
        title: "$30B Digital Assets Securely Processed, 0 Hacks",
        description: `Keys are divided into three, two of which are 
managed by you. Two keys are stored in your 
infrastructure.`,
      },
      supportWallet: {
        title: `Build Your Own Crypto wallet system,
in 2 days`,
        description: `Clients develop wallet services with Henesis only 
for 2 days to 2 weeks.`,
      },
      saveGasFees: {
        title: `Save Ethereum Gas Fee,
by 95%`,
        description: `Henesis can save a major global exchange $43M 
annually on Ethereum gas fee, 95%.`,
      },
    },
    securitySection: {
      title: `Crypto Wallet API With
World-Class Security`,
      learnMoreButton: `LEARN MORE ABOUT Henesis`,
      multisigWallet: {
        title: "Multi-Sig Wallet",
        description: `Enhance your wallet security by distributed keys and 
easy recovery from losing your key.`,
      },
      hackingGuard: {
        title: "Hacking Resistant",
        description: `Prevent hacking with IP whitelisting, withdrawal 
addres whitelisting, Access Token authentication, 
OTP TFA, and many more security measures.`,
      },
      authSeperation: {
        title: "Identity And Access Management",
        description: `Grant each member a different level of permission 
and access via a UI/UX friendly dashboard.`,
      },
    },
    saveGasFeesSection: {
      title: `Save Up To 95% 
Gas Fees`,
      description: `A global top 10 exchange can save 1 million to
42 million usd gas fee.`,
      registerButton: `GAS FEE ANALYSIS FOR FREE`,
    },
    dashboardSection: {
      title: `Keep Everything
In One Place`,
      description: `From individal tx information to withdrawal approval 
request, monitor and manage all the activities related 
to your wallet in single dashboard.`,
      homepage: "TRY DASHBOARD FOR FREE",
    },
    apiSection: {
      title: `Most Powerful Crypto 
Integration API `,
      description: `Easily integrate digital assets and crypto businesses 
via simple API, in just a few days.`,
      homepage: "READ THE DEV DOCS",
    },
    customerSection: {
      title: `Trusted By 
Banks, Fintech & Crypto Services`,
      description: `HAECHI LABS works with major banks, digital asset custody & crypto services around the world.`,
      moreText: `SEE MORE`,
    },
    tryItSection: {
      title: "Start Integration Today",
      confirmButton: "TALK TO SALES",
    },
    footer: {
      description: `12F, 179, Bongeunsa-ro, Gangnam-gu, Seoul, Republic of Korea`,
    },
    productServiceSection: {
      title: `How Henesis Works`,
      description: `Henesis is a multi-sig wallet solution that enables customers to safely manage their own assets.
You can build a safe wallet system conveniently just by integrating with Henesis API.
To create a multi-sig transaction, a client has to sign a transaction first and so does Henesis.`,
    },
    enterpriseGradeSecuritySection: {
      tabs: {
        multisig: `Multi-sig wallet`,
        authority: `Policy Engine`,
        withdrawalPolicy: `Workflow Engine`,
        networkSecurity: `Network Security`,
        monitoring: `Monitoring`,
      },
      title: `Enterprise-Grade Security`,
      description: `Henesis secures customers digital assets from external hacking and insider attacks.
Multi-sig wallet, network security and policy engine help you to prevent various hacking senarios.`,
    },
    transactionFeeManagementSection: {
      title: `Transaction Fee Managment`,
      item1: {
        title: `Save by 95% Gas Fee`,
        description: `By optimizing the multi-sig smart contract, it is possible to build 
a large-scale wallet system without huge operating 
costs.`,
        linkText: `LEARN MORE`,
      },
      item2: {
        title: `Fee Wallet`,
        description: `You no longer need to manage fees yourself to create 
transactions. All transaction fees are paid by assets deposited 
in the fee wallet.`,
        linkText: `LEARN MORE`,
      },
    },
    productSaveGasFeesSection: {
      title: `Ready for Saving 95% Gas Fee?`,
      confirmButton: `TALK TO SALES`,
    },
    dashboardAndAPISection: {
      title: `Easy-To-Use API, Dashboard For Your Workflow`,
      dashboard: {
        subTitle: `Dashboard`,
        linkText: `EXPLORE DASHBOARD`,
        item1: {
          title: `Manage Your Digital Asset Easily`,
          description: `You can monitor the deposit, withdrawal, and balance and use policy engine.`,
        },
        item2: {
          title: `Create a master wallet`,
          description: `You can easily create a multi-sig wallet just by setting a wallet password, and will get a recovery kit`,
        },
        item3: {
          title: `Deposit & Withdrawal History`,
          description: `You can monitor deposit and withdrawal history in real time. Check the status of the transaction to confirm that the transaction has been completed.`,
        },
        item4: {
          title: `Withdrawal`,
          description: `You can safely transfer digital assets through the dashboard by entering your wallet password and OTP code.`,
        },
        item5: {
          title: `Fee History`,
          description: `You can see at a glance the history of all transaction fee usage, and you can download the fee usage history as evidence for auditing.`,
        },
      },
      api: {
        subTitle: `API`,
        title: `Focus On Your Business Logic, 
Regardless Of Your 
Environment`,
        description: `Easily integrate digital assets and crypto businesses 
via simple API, in just a few days.`,
        linkText: `READ THE DOCS`,
      },
    },
    blockchainSection: {
      title: `Multi Currency Platform`,
      description: `Henesis support six blockchain protocols and 300+ coins.
We are supproting more blockchain protocols.`,
      blockchain: {
        btc: `Bitcoin 
(BTC)`,
        eth: `Ethereum 
(ETH)`,
        klay: `Klaytn 
(KLAY)`,
        fil: `Filecoin 
(FIL)`,
        ltc: `Litecoin 
(LTC)`,
        bch: `Bitcoin Cash 
(BCH)`,
        bsc: `Binance Smart Chain 
(BSC)`,
        others: `Coming Soon`,
      },
    },
    requestAudit: "REQUEST AN AUDIT",
  },
};

export default en;
